import { render, staticRenderFns } from "./UGhostLoader.vue?vue&type=template&id=3e1ec517&scoped=true&"
import script from "./UGhostLoader.vue?vue&type=script&lang=js&"
export * from "./UGhostLoader.vue?vue&type=script&lang=js&"
import style0 from "./UGhostLoader.vue?vue&type=style&index=0&id=3e1ec517&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1ec517",
  null
  
)

export default component.exports